import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { quiz } from '../data/village-data';
import { useAuth } from '../context/AuthContext';
import ManifestorCard from './ManifestorCard';

const API = process.env.REACT_APP_BACKEND_URL;

export default function QuizPage() {
  const navigate = useNavigate();
  const { user, token, updateUser } = useAuth();
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const [resultKey, setResultKey] = useState(null);
  const [showCard, setShowCard] = useState(false);

  const handleAnswer = async (archetype) => {
    const updated = { ...answers, [currentQ]: archetype };
    setAnswers(updated);

    if (currentQ < quiz.questions.length - 1) {
      setCurrentQ(currentQ + 1);
    } else {
      const counts = {};
      Object.values(updated).forEach((a) => {
        counts[a] = (counts[a] || 0) + 1;
      });
      const top = Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0];
      const arch = quiz.archetypes[top];
      setResult(arch);
      setResultKey(top);

      // Save archetype to profile if logged in
      if (token) {
        try {
          await fetch(`${API}/api/profile/archetype`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ archetype: top, archetype_name: arch.name }),
          });
          updateUser({ archetype: top, archetype_name: arch.name });
        } catch { /* silent */ }
      }
    }
  };

  const q = quiz.questions[currentQ];

  if (result) {
    return (
      <section data-testid="quiz-result" className="quiz-page quiz-result-page">
        {showCard && (
          <ManifestorCard
            name={user?.name || 'Village Manifestor'}
            archetypeKey={resultKey}
            onClose={() => setShowCard(false)}
          />
        )}
        <div className="quiz-content">
          <p className="quiz-result-label">Your Village Archetype</p>
          <h1 data-testid="archetype-name" className="archetype-name">{result.name}</h1>
          <p className="archetype-description">{result.description}</p>
          <div className="quiz-result-actions">
            <button data-testid="get-card-btn" className="village-btn village-btn--primary" onClick={() => setShowCard(true)}>
              Get Your Manifestor Card
            </button>
            <button data-testid="enter-lifemap-btn" className="village-btn village-btn--secondary" onClick={() => navigate('/life-map')}>
              Enter the Village Life-Map
            </button>
            <button data-testid="go-suggested-path-btn" className="village-btn village-btn--secondary" onClick={() => navigate(result.suggestedPath)}>
              Go to {result.pathName}
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section data-testid="quiz-page" className="quiz-page">
      <div className="quiz-content">
        <h1 className="quiz-title">{quiz.title}</h1>
        <p className="quiz-description">{quiz.description}</p>
        <div className="quiz-progress">
          <div className="quiz-progress-bar">
            <div className="quiz-progress-fill" style={{ width: `${((currentQ + 1) / quiz.questions.length) * 100}%` }} />
          </div>
          <span className="quiz-progress-text">{currentQ + 1} of {quiz.questions.length}</span>
        </div>
        <div data-testid="quiz-question" className="quiz-question" key={q.id}>
          <h2 className="question-text">{q.text}</h2>
          <div className="quiz-options">
            {q.options.map((opt, i) => (
              <button key={i} data-testid={`quiz-option-${i}`} className="quiz-option" onClick={() => handleAnswer(opt.archetype)}>
                {opt.text}
              </button>
            ))}
          </div>
        </div>
        <button data-testid="skip-quiz-btn" className="auth-skip" onClick={() => navigate('/life-map')}>
          Skip and explore the Village
        </button>
      </div>
    </section>
  );
}
